import React from "react";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";
import BackArrowButton from "../parts/back-arrow-button";

class LoginPasswordView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordType: "password",
    };
    this.changePasswordType = this.changePasswordType.bind(this);
  }
  componentDidMount() {
    document.querySelector('input[name="password"]').focus();
  }

  changePasswordType(e) {
    e.preventDefault();

    if (this.state.passwordType === "password") {
      this.setState({ passwordType: "text" });
      return;
    }
    this.setState({ passwordType: "password" });
  }

  render() {
    const {
      handlePasswordChange,
      handlePasswordLogin,
      email,
      handleEmailChange,
      onBack,
    } = this.props;

    return (
      <LoginWrapper
        left={
          <form method="POST" data-noreset>
            <BackArrowButton onBack={(_) => onBack(0)} />
            <div>
              <h1>Login</h1>
            </div>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              value={email}
              required
              onChange={handleEmailChange}
              placeholder="Enter email here"
              sz="large"
            />

            <div className="input-password-wrapper">
              <label htmlFor="password">Password</label>
              <input
                type={this.state.passwordType}
                name="password"
                required
                onChange={handlePasswordChange}
                placeholder="******"
                sz="large"
              />
              <button
                data-button-type="text-white"
                data-icon-only=""
                onClick={(e) => this.changePasswordType(e)}
                tabIndex="-1"
                type="button"
                sz="large"
              >
                <SvgIcon
                  src={
                    this.state.passwordType === "password"
                      ? "/img/new-icons/eye.svg"
                      : "/img/new-icons/eye-slash.svg"
                  }
                  alt="eye"
                />
              </button>
            </div>

            <button
              data-button-type="primary"
              type="submit"
              sz="large"
              onClick={handlePasswordLogin}
            >
              Continue
            </button>

            <a data-button-type="text-white" href={`/forgot?email=${email}`}>
              Forgot Password
            </a>
          </form>
        }
      />
    );
  }
}

export default LoginPasswordView;
